export default __webpack_public_path__ + "static/media/Minicard_Ks.a718253d.svg";